module.exports = __webpack_public_path__ + "static/finalist seal_NSW_Best Finance Broker-f7d776b29e8e7e90f97e4405c000432c.png";